import { useContext } from 'react'

import { FormFieldContext } from '@/components/ui/form'

/**
 * Resolve o `name` de um controle.
 *
 * Dentro de `<Field name="x">` o nome vem do contexto e o controle não precisa
 * repeti-lo. Fora dele, o nome vem por prop.
 *
 * O segundo caminho existe para adoção incremental: a camada é aditiva e conta
 * com 40 telas usando `FormGroup`. Exigir a troca do wrapper inteiro para
 * aproveitar um campo novo tornaria cada migração grande demais para valer a
 * pena, e a camada nunca seria adotada.
 *
 * **O que se perde fora do `Field`:** a associação de rótulo, o
 * `aria-describedby` da descrição e do erro, e o `aria-invalid` — tudo isso é
 * injetado por `Field.Control`. Fora dele o controle é um campo estilizado e
 * registrado, nada além. Código novo deve usar o `Field`.
 */
export function useControlName(nameProp?: string): string {
  const fieldContext = useContext(FormFieldContext)
  const name = nameProp ?? fieldContext?.name

  if (!name) {
    throw new Error(
      'Controle de formulário sem `name`: use-o dentro de <Field name="..."> ou passe a prop `name`.'
    )
  }

  return name
}
